import * as Yup from "yup"

export const FormValidation = (step, type) => {
    if(type === '')
        return Yup.object({});
    if(type === 'single'){
        switch(step){
            case 0:
                return Yup.object({
                    name: Yup.string().min(3,'Must be atleast 3 characters').required('Required').matches(/^[aA-zZ.\s]+$/, "Only alphabets are allowed for this field "),
                    dob: Yup.date().required('Required'),
                    gender: Yup.string().required('Gender is required'),
                    profile_image: Yup.string().required('Profile image is required'),
                    blood_group: Yup.string().oneOf(['A+','A-','B+','B-','AB+','AB-','O+','O-']).required('Required'),
                    phone:  Yup.string().required('Mobile Number is Required').matches(/^[0-9]+$/, 'Moblie Number should be a number').min(10, 'Please enter valid Moblie Number').max(12, 'Enter valid Moblie number'),
                    email: Yup.string().email('Please enter valid Email').required('Required'),
                    signature_image: Yup.string().required('Signature Image is required')
                })
            case 1:
                return Yup.object({
                    // docstatus: Yup.string().required('Status is required'),
                    qualifications: Yup.string().required('Required'),
                    specialization: Yup.string(),
                    // college: Yup.string().required('Required').matches(/^[aA-zZ.,\s]+$/, "Only alphabets are allowed for this field "),
                    college: Yup.string().required("College name is required. "),
                    regno: Yup.string().required('Required'),
                    cert_image: Yup.string().required('Document file is required')
                })
            case 2:
                return Yup.object({
                    line1: Yup.string().required('Required'),//address seperate page
                    line2: Yup.string(),
                   
                    state: Yup.string().required('State is Required'),
                    city: Yup.string().required('City is Required'),
                    pincode: Yup.number('Pin code should be a number').integer('Pin code should be a number').lessThan(1000000, "Enter valid pin code").moreThan(99999, "Enter valid pin code").required('Pin code is Required')
                })
            case 3:
                return Yup.object({
                    nmo_state: Yup.string().required('Required'),
                    prant: Yup.string().required('Required'),
                    nmo_unit: Yup.string(),//next page (Association with NMO)
                    ref_person: Yup.string().required('Required'),
                    ref_membership_no: Yup.number().positive().integer().required('Membership Number should be a number'),
                    ref_person_phone:  Yup.string().required('Mobile Number is Required').matches(/^[0-9]+$/, 'Moblie Number should be a number').min(10, 'Please enter valid Moblie Number').max(12, 'Enter valid Moblie number'),
                    state_sec_email: Yup.string().email('Please enter valid Email').required('Required')
                })
            default:
                return Yup.object({
                    // dob: Yup.date().required('Required'),
                    // profile_image: Yup.string().required('Profile image is required'),
                    // phone: Yup.number().positive().integer().moreThan(999999999,'Please enter valid mobile number').lessThan(10000000000,'Please enter valid mobile number').required('Mobile Number is required'),
                    // email: Yup.string().email('Please enter valid Email').required('Required'),
                    // signature_image: Yup.string().required('Signature Image is required'),
                    // qualifications: Yup.string().required('Required'),
                    // // college: Yup.string().required('Required').matches(/^[aA-zZ.,\s]+$/, "Only alphabets are allowed for this field "),
                    // college: Yup.string().required("College name is required. "),
                    // regno: Yup.string().required('Required'),
                    // cert_image: Yup.string().required('Document file is required'),
                    // line1: Yup.string().required('Required'),//address seperate page
                    // line2: Yup.string(),
                    // collage_state: Yup.string().required('Collage State is Required'),
                    // state: Yup.string().required('State is Required'),
                    // city: Yup.string().required('City is Required'),
                    // pincode: Yup.number('Pin code should be a number').integer('Pin code should be a number').lessThan(1000000, "Enter valid pin code").moreThan(99999, "Enter valid pin code").required('Pin code is Required'),
                    // nmo_state: Yup.string().required('Required'),
                    // prant: Yup.string().required('Required'),
                    // nmo_unit: Yup.string(),//next page (Association with NMO)
                    // ref_person: Yup.string().required('Required'),
                    // ref_membership_no: Yup.number().positive().integer().required('Membership Number should be a number'),
                    // ref_person_phone: Yup.number().positive().integer().moreThan(999999999,'Please enter valid mobile number').lessThan(10000000000,'Please enter valid mobile number').required('Mobile Number is required'),
                    // state_sec_email: Yup.string().email('Please enter valid Email').required('Required')
                })
        }
    }
    if(type === 'student'){
        switch(step){
            case 0:
                return Yup.object({
                    name: Yup.string().min(3,'Must be atleast 3 characters').required('Required').matches(/^[aA-zZ.\s]+$/, "Only alphabets are allowed for this field "),
                    dob: Yup.date().required('Required'),
                    gender: Yup.string().required('Gender is required'),
                    profile_image: Yup.string().required('Profile image is required'),

                    blood_group: Yup.string().oneOf(['A+','A-','B+','B-','AB+','AB-','O+','O-']).required('Required'),
                    phone: Yup.string().required('Mobile Number is Required').matches(/^[0-9]+$/, 'Moblie Number should be a number').min(10, 'Please enter valid Moblie Number').max(12, 'Enter valid Moblie number'),
                    email: Yup.string().email('Please enter valid Email').required('Required'),
                    signature_image: Yup.string().required('Signature Image is required')
                })
            case 1:
                return Yup.object({
                    // docstatus: Yup.string().required('Degree is required'),
                    qualifications: Yup.string().required('it is Required'),
                    degree:Yup.string().oneOf(['1st year','2nd year', '3rd year' ,'4th year']).required('required'),
                    // specialization: Yup.string(),
                    // college: Yup.string().required('Required').matches(/^[aA-zZ.,\s]+$/, "Only alphabets are allowed for this field "),
                    college: Yup.string().required("College name is required. "),
                    regno: Yup.string().required('Required'),
                    cert_image: Yup.string().required('Document file is required')
                })
            case 2:
                return Yup.object({
                    line1: Yup.string().required('Required'),//address seperate page
                    line2: Yup.string(),
                   
                    state: Yup.string().required('State is Required'),
                    city: Yup.string().required('City is Required'),
                    pincode: Yup.number('Pin code should be a number').integer('Pin code should be a number').lessThan(1000000, "Enter valid pin code").moreThan(99999, "Enter valid pin code").required('Pin code is Required')
                })
            case 3:
                return Yup.object({
                    nmo_state: Yup.string().required('Required'),
                    prant: Yup.string().required('Required'),
                    nmo_unit: Yup.string(),//next page (Association with NMO)
                    ref_person: Yup.string().required('Required'),
                    ref_membership_no: Yup.number().positive().integer().required('Membership Number should be a number'),
                    ref_person_phone: Yup.string().required('Mobile Number is Required').matches(/^[0-9]+$/, 'Moblie Number should be a number').min(10, 'Please enter valid Moblie Number').max(12, 'Enter valid Moblie number'),
                    state_sec_email: Yup.string().email('Please enter valid Email').required('Required')
                })
            default:
                return Yup.object({
                    // dob: Yup.date().required('Required'),
                    // profile_image: Yup.string().required('Profile image is required'),
                    // phone: Yup.number().positive().integer().moreThan(999999999,'Please enter valid mobile number').lessThan(10000000000,'Please enter valid mobile number').required('Mobile Number is required'),
                    // email: Yup.string().email('Please enter valid Email').required('Required'),
                    // signature_image: Yup.string().required('Signature Image is required'),
                    // qualifications: Yup.string().required('Required'),
                    // // college: Yup.string().required('Required').matches(/^[aA-zZ.,\s]+$/, "Only alphabets are allowed for this field "),
                    // college: Yup.string().required("College name is required. "),
                    // regno: Yup.string().required('Required'),
                    // cert_image: Yup.string().required('Document file is required'),
                    // line1: Yup.string().required('Required'),//address seperate page
                    // line2: Yup.string(),
                    // collage_state: Yup.string().required('Collage State is Required'),
                    // state: Yup.string().required('State is Required'),
                    // city: Yup.string().required('City is Required'),
                    // pincode: Yup.number('Pin code should be a number').integer('Pin code should be a number').lessThan(1000000, "Enter valid pin code").moreThan(99999, "Enter valid pin code").required('Pin code is Required'),
                    // nmo_state: Yup.string().required('Required'),
                    // prant: Yup.string().required('Required'),
                    // nmo_unit: Yup.string(),//next page (Association with NMO)
                    // ref_person: Yup.string().required('Required'),
                    // ref_membership_no: Yup.number().positive().integer().required('Membership Number should be a number'),
                    // ref_person_phone: Yup.number().positive().integer().moreThan(999999999,'Please enter valid mobile number').lessThan(10000000000,'Please enter valid mobile number').required('Mobile Number is required'),
                    // state_sec_email: Yup.string().email('Please enter valid Email').required('Required')

                })
        }
    }
    else
    {
        switch(step){
            case 0:
                return Yup.object({
                    name: Yup.string().min(3,'Must be atleast 3 characters').required('Required').matches(/^[aA-zZ.\s]+$/, "Only alphabets are allowed for this field "),
                    dob: Yup.date().required('Required'),
                    gender: Yup.string().required('Gender is required'),
                    profile_image: Yup.string().required('Profile image is required'),
                    blood_group: Yup.string().oneOf(['A+','A-','B+','B-','AB+','AB-','O+','O-']).required('Required'),
                    phone: Yup.string().required('Mobile Number is Required').matches(/^[0-9]+$/, 'Moblie Number should be a number').min(10, 'Please enter valid Moblie Number').max(12, 'Enter valid Moblie number'),
                    email: Yup.string().email('Please enter valid Email').required('Required'),
                    signature_image: Yup.string().required('Signature Image is required')
                })
            case 1:
                return Yup.object({
                    // docstatus: Yup.string().required('Status is required'),
                    qualifications: Yup.string().required('Required'),
                    specialization: Yup.string(),
                    // college: Yup.string().required('Required').matches(/^[aA-zZ.,\s]+$/, "Only alphabets are allowed for this field "),
                    college: Yup.string().required("College name is required. "),
                    regno: Yup.string().required('Required'),
                    cert_image: Yup.string().required('Document file is required')
                })
            case 2:
                return Yup.object({
                    name1: Yup.string().min(3,'Must be atleast 3 characters').required('Required').matches(/^[aA-zZ.\s]+$/, "Only alphabets are allowed for this field "),
                    dob1: Yup.date().required('Required'),
                    gender1: Yup.string().required('Gender is required'),
                    profile_image1: Yup.string().required('Profile image is required'),
                    blood_group1: Yup.string().oneOf(['A+','A-','B+','B-','AB+','AB-','O+','O-']).required('Required'),
                    phone1: Yup.number().positive().integer('Phone number should be a number').moreThan(999999999,'Please enter valid mobile number').lessThan(10000000000,'Please enter valid mobile number').required('Mobile Number is required'),
                    email1: Yup.string().email('Please enter valid Email').required('Required'),
                    signature_image1: Yup.string().required('Signature Image is required')
                })
            case 3:
                return Yup.object({
                    docstatus1: Yup.string().required('Status is required'),
                    qualifications1: Yup.string().required('Required'),
                    specialization1: Yup.string(),
                    // college1: Yup.string().required('Required').matches(/^[aA-zZ.,\s]+$/, "Only alphabets are allowed for this field "),
                    college1: Yup.string().required("College name is required. "),
                    regno1: Yup.string().required('Required'),
                    cert_image1: Yup.string().required('Document file is required')
                })
            case 4:
                return Yup.object({
                    line1: Yup.string().required('Required'),//address seperate page
                    line2: Yup.string(),
                    city: Yup.string().required('City is Required'),
                    state: Yup.string().required('State is Required'),
                    pincode: Yup.number('Pin code should be a number').integer('Pin code should be a number').lessThan(1000000, "Enter valid pin code").moreThan(99999, "Enter valid pin code").required('Pin code is Required')
                })
            case 5:
                return Yup.object({
                    nmo_state: Yup.string().required('Required'),
                    prant: Yup.string().required('Required'),
                    nmo_unit: Yup.string(),//next page (Association with NMO)
                    ref_person: Yup.string().required('Required'),
                    ref_membership_no: Yup.number().positive().integer().required('Membership Number should be a number'),
                    ref_person_phone: Yup.string().required('Mobile Number is Required').matches(/^[0-9]+$/, 'Moblie Number should be a number').min(10, 'Please enter valid Moblie Number').max(12, 'Enter valid Moblie number'),
                    state_sec_email: Yup.string().email('Please enter valid Email').required('Required')
                })
            default:
                return Yup.object({
                    // dob: Yup.date().required('Required'),
                    // profile_image: Yup.string().required('Profile image is required'),
                    // phone: Yup.number().positive().integer().moreThan(999999999,'Please enter valid mobile number').lessThan(10000000000,'Please enter valid mobile number').required('Mobile Number is required'),
                    // email: Yup.string().email('Please enter valid Email').required('Required'),
                    // signature_image: Yup.string().required('Signature Image is required'),
                    // qualifications: Yup.string().required('Required'),
                    // // college: Yup.string().required('Required').matches(/^[aA-zZ.,\s]+$/, "Only alphabets are allowed for this field "),
                    // college: Yup.string().required("College name is required. "),
                    // regno: Yup.string().required('Required'),
                    // cert_image: Yup.string().required('Document file is required'),
                    // line1: Yup.string().required('Required'),//address seperate page
                    // line2: Yup.string(),
                    // collage_state: Yup.string().required('Collage State is Required'),
                    // state: Yup.string().required('State is Required'),
                    // city: Yup.string().required('City is Required'),
                    // pincode: Yup.number('Pin code should be a number').integer('Pin code should be a number').lessThan(1000000, "Enter valid pin code").moreThan(99999, "Enter valid pin code").required('Pin code is Required'),
                    // nmo_state: Yup.string().required('Required'),
                    // prant: Yup.string().required('Required'),
                    // nmo_unit: Yup.string(),//next page (Association with NMO)
                    // ref_person: Yup.string().required('Required'),
                    // ref_membership_no: Yup.number().positive().integer().required('Membership Number should be a number'),
                    // ref_person_phone: Yup.number().positive().integer().moreThan(999999999,'Please enter valid mobile number').lessThan(10000000000,'Please enter valid mobile number').required('Mobile Number is required'),
                    // state_sec_email: Yup.string().email('Please enter valid Email').required('Required')
                })
        }
    }
}
